export enum MarketplaceEnum {
  Amazon = 1,
}

/** Espelha MarketplaceListingStatusEnum da API (marketplace_listing.id_listing_status). */
export enum MarketplaceListingStatusEnum {
  Pendente = 1,
  Publicando = 2,
  Publicado = 3,
  Erro = 4,
  RemocaoPendente = 5,
  Removido = 6,
}

/** Espelha MarketplaceSyncStatusEnum da API (marketplace_sync_log.id_sync_status). */
export enum MarketplaceSyncStatusEnum {
  Success = 1,
  Error = 2,
  Info = 3,
}
